import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import {
  updateShippingRestriction,
  getUpdateShippingRestrictionStatus,
  cleanUpdateShippingRestrictionStatus,
} from '../../deliveryMethodsSlice';
import {
  ShippingRestrictionFormValues,
  formValuesToDto,
} from '../../pages/ShippingRestrictionPages/types';

function useUpdateShippingRestriction() {
  const dispatch = useAppDispatch();
  const status = useSelector(getUpdateShippingRestrictionStatus);

  useEffect(() => {
    dispatch(cleanUpdateShippingRestrictionStatus());
  }, [dispatch]);

  const update = useCallback(
    async (id: string, formValues: ShippingRestrictionFormValues) => {
      const dto = formValuesToDto(formValues);
      await dispatch(updateShippingRestriction({ id, payload: dto }));
    },
    [dispatch],
  );

  return {
    update,
    isLoading: status === 'loading',
    isSuccess: status === 'success',
    isError: status === 'error',
    status,
  };
}

export default useUpdateShippingRestriction;
